// extracted by mini-css-extract-plugin
export default {"ag-styles":"by_g","searchForm":"by_QS"};